export default {
    clientId: "8puWuJWZYls1Ylawxm6CMiYREhsGGSyw",
    assetsUrl: "https://ubelong-dev2.s3-eu-west-1.amazonaws.com/",
    //url: "http://localhost:3030/",
    url: {
        staging: "https://stagingapi.ubelong.io/",
        production: process.env.REACT_APP_API_URL,
    }
};
